import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { SortType } from "../../SortType";

export interface MockupsAnalyticsFilters {
  order_id: FilterValue[] | null;
  customer_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
  admin_id: FilterValue[] | null;
  mockup_time: FilterValue | null;
}

export interface MockupsAnalyticsSelectedFilters {
  order_id: FilterValue[] | null;
  customer_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  start_date: string;
  end_date: string;
  admin_id: FilterValue[] | null;
  mockup_time: FilterValue | null;
}

export interface MockupsAnalyticsAPIFilters {
  order_id: FilterValue[] | null;
  customer_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  start_date: string;
  end_date: string;
  admin_id: FilterValue[] | null;
  mockup_time: string | null;
}

export function parseQueryParamsForMockupsAnalyticsFilters(
  params: MockupsAnalyticsFilters | null,
  query_params: URLSearchParams
): MockupsAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    order_id: params?.order_id ?? [],
    customer_id: params?.customer_id ?? [],
    order_type: params?.order_type ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    admin_id: params?.admin_id ?? [],
    mockup_time: params?.mockup_time ?? null,
  };
}
